import { observable, action } from 'mobx'
import { PAGE_SIZE } from '../helpers/constants'
import { Request2 } from 'src/common/Request2'
import api from 'src/common/api'
import { isEmpty } from 'lodash'
import { responseDefault } from './store.constants'

export class ServiceStore {
   @observable serviceList: any = { ...responseDefault }

   @action
   async getServiceList(params: any = {}) {
      const result = await Request2.getWithToken(api.service.getListAdmin, { ...params, limit: PAGE_SIZE })
      if (!isEmpty(result)) {
         this.serviceList = result
      } else {
         this.serviceList = { ...responseDefault }
      }
   }

   @action
   async getServiceListForUser(params: any = {}) {
      const result = await Request2.getWithToken(api.service.getList, { ...params, limit: 100 })
      if (!isEmpty(result)) {
         return result
      }
      return { rows: [], count: 0 }
   }

   @action
   async createService(data: { name: string; price: number; visibleTo?: number[] | null }) {
      const DOMAIN = `${api.service.create}`
      const result = await Request2.postWithToken(data, DOMAIN)
      return result
   }

   @action
   async updateService(id: number, data: { name?: string; price?: number; visibleTo?: number[] | null }) {
      const DOMAIN = `${api.service.update}/${id}`
      const result = await Request2.putWithToken(data, DOMAIN)
      return result
   }

   @action
   async deleteService(id: number) {
      const DOMAIN = `${api.service.delete}/${id}`
      const result = await Request2.deleteWithToken({}, DOMAIN)
      return result
   }
}
